import axios from "./axiosInstance";

const userAPI ={ 
details: () => axios.get("profile"),
    
}

export default userAPI;